import { render, staticRenderFns } from "./ContentService.vue?vue&type=template&id=52ecda12&"
import script from "./ContentService.vue?vue&type=script&lang=js&"
export * from "./ContentService.vue?vue&type=script&lang=js&"
import style0 from "./ContentService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports